import { Box, CircularProgress, Stack } from '@mui/material';
import PageHead from '../admin/PageHead';

const LoaderText = () => {
    return <Box sx={{ px: 2, py: 1.5, width: '100%', height: '100%', position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>

        <PageHead primary={  <CircularProgress color="success"size="60px"   />} />

    </Box>
}

export default LoaderText;